module.exports = __webpack_public_path__ + "img/video-image.d65880f3.png";